import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { setFadeoutAppAction } from '../../../app/action'
import { addClassToDOM, removeClassToDOM } from '../../../utilities/function/common'

let KeepShoppingButton = (props) => {
  const dispatch = useDispatch()
  const { history, className, callback ,label} = props
  const keepShoppingCallback = useCallback((e) => {
    e.preventDefault()
    if (callback) {
      callback()
    }
    dispatch(setFadeoutAppAction(true))
    window.setTimeout(() => {
      dispatch(setFadeoutAppAction(false))
      history.push(history.location.pathname)
    }, 300)

  }, [history, dispatch, callback])
  return (
    <button className={`of-keep-shopping-button reset-button lines-border-1-100 text-font-3-100${className ? ' ' + className : ''}`}
            onClick={keepShoppingCallback}
            onMouseEnter={e => {
              removeClassToDOM(e.currentTarget, 'text-font-3-100')
              removeClassToDOM(e.currentTarget, 'lines-border-1-100')
              addClassToDOM(e.currentTarget, 'text-font-4-100')
              addClassToDOM(e.currentTarget, 'text-border-4-100')
            }}
            onMouseLeave={e => {
              removeClassToDOM(e.currentTarget, 'text-font-4-100')
              removeClassToDOM(e.currentTarget, 'text-border-4-100')
              addClassToDOM(e.currentTarget, 'text-font-3-100')
              addClassToDOM(e.currentTarget, 'lines-border-1-100')
            }}
    >
      <span className='text'>{label?label:'Keep Shopping'}</span><i className='icon icon-of-blog-close'/>
    </button>
  )
}

KeepShoppingButton.propTypes = {
  history: PropTypes.any,
  className: PropTypes.string,
  label: PropTypes.string
}

KeepShoppingButton = withRouter(KeepShoppingButton)

export default KeepShoppingButton